import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Sparkles, Magnet, Calculator, Boxes, Bot, TrendingUp, ArrowRight, Check } from "lucide-react";
import { WhatsAppSupport } from "../WhatsAppSupport";

const black = "#111111";
const accent = "#0f9d58";
const BASE = process.env.REACT_APP_BACKEND_URL;

const IMG = {
  hero: "https://images.unsplash.com/photo-1758691737492-48e8fdd336f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGdyb3d0aCUyMHNjYWxpbmclMjB0ZWFtJTIwc3VjY2Vzc3xlbnwwfHx8fDE3OTA1MTg2MDR8MA&ixlib=rb-4.1.0&q=85&w=1200",
  story: "https://images.unsplash.com/photo-1589793463357-5fb813435467?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxjdXN0b20lMjBtYW51ZmFjdHVyaW5nJTIwd29ya3Nob3AlMjBwcm9kdWN0aW9ufGVufDB8fHx8MTc5MDUxODYwM3ww&ixlib=rb-4.1.0&q=85&w=1200",
  magnet: "https://images.unsplash.com/photo-1549923746-c502d488b3ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGhhbmRzaGFrZSUyMHBhcnRuZXJzaGlwJTIwbWVldGluZ3xlbnwwfHx8fDE3OTA1MTg2MDN8MA&ixlib=rb-4.1.0&q=85&w=1200",
  config: "https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxlbmdpbmVlciUyMGxhcHRvcCUyMHRlY2huaWNhbCUyMGNvbmZpZ3VyYXRpb258ZW58MHx8fHwxNzkwNTE4NjAzfDA&ixlib=rb-4.1.0&q=85&w=1200",
  erp: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGRhc2hib2FyZCUyMGFuYWx5dGljcyUyMHNjcmVlbnxlbnwwfHx8fDE3OTA1MTg2MDN8MA&ixlib=rb-4.1.0&q=85&w=1200",
  ai: "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlJTIwYXNzaXN0YW50JTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3OTA1MTg2MDR8MA&ixlib=rb-4.1.0&q=85&w=1200",
};

function PlatformContactForm() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [state, setState] = useState("idle");
  const [err, setErr] = useState("");
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (form.name.trim().length < 2 || !form.email.trim()) {
      setErr("Completeaza numele si emailul.");
      return;
    }
    setState("sending");
    try {
      await axios.post(`${BASE}/api/public/contact`, {
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim() || null,
        message: form.message.trim() || null,
      });
      setState("done");
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Trimiterea a esuat. Reincearca.");
      setState("error");
    }
  };

  const inputCls = "w-full px-3 py-2.5 rounded-md border border-gray-300 focus:border-gray-900 outline-none transition-colors";

  if (state === "done") {
    return (
      <div className="border border-gray-300 rounded-lg p-6 text-center" data-testid="home-contact-success">
        <Check className="w-7 h-7 mx-auto mb-2" style={{ color: accent }} />
        <p className="font-bold" style={{ fontSize: "15px" }}>Mesaj trimis</p>
        <p className="mt-1">Iti multumim. Te contactam cat mai curand.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="border border-gray-300 rounded-lg p-6 space-y-3" data-testid="home-contact-form" style={{ fontSize: "14px" }}>
      <input value={form.name} onChange={set("name")} placeholder="Nume" required
        data-testid="home-contact-name" className={inputCls} />
      <input value={form.email} onChange={set("email")} type="email" placeholder="Email" required
        data-testid="home-contact-email" className={inputCls} />
      <input value={form.phone} onChange={set("phone")} placeholder="Telefon"
        data-testid="home-contact-phone" className={inputCls} />
      <textarea value={form.message} onChange={set("message")} placeholder="Spune-ne in cateva randuri despre afacerea ta" rows={4}
        data-testid="home-contact-message" className={inputCls} />
      {err && <p className="text-red-600" data-testid="home-contact-error">{err}</p>}
      <button type="submit" disabled={state === "sending"} data-testid="home-contact-submit"
        className="px-5 py-2.5 rounded-md text-white disabled:opacity-60 hover:opacity-90 transition-opacity" style={{ backgroundColor: black }}>
        {state === "sending" ? "Se trimite..." : "Trimite mesajul"}
      </button>
    </form>
  );
}

const ecosystem = [
  {
    icon: Magnet,
    img: IMG.magnet,
    t: "Magnet de lead-uri",
    d: "Daca produci, vinzi, sau oferi servicii, iti poate gasi Yvola parteneri in Uniunea Europeana.\n\nDupa crearea contului introduci adresa site-ului tau ca sa te cunoasca AI-ul nostru si sa pregateasca strategia de abordare a potentialilor tai parteneri.\n\nDaca nu ai un site, poti atasa cateva foto (chiar facute cu telefonul) ale produselor tale si un text care descrie activitatea ta.",
  },
  {
    icon: Calculator,
    img: IMG.config,
    t: "Configurator personalizat",
    d: "Partenerii tai obtin informatii si fac simulari de pret 7 zile din 7 si 24 de ore din 24, fara sa incarci costurile cu personal, birouri sau timp de raspuns. Ideal cand vinzi produse sau servicii complexe, nestandard.",
  },
  {
    icon: Boxes,
    img: IMG.erp,
    t: "ERP complet",
    d: "Aplicatia de care probabil ai mai auzit. Cuprinde majoritatea modulelor necesare functionarii unei companii, de la 2-3 angajati pana la mii de angajati. Toate datele intr-un singur loc, ordonate.",
  },
];

export default function Home() {
  return (
    <div
      style={{ fontFamily: "Arial, sans-serif", fontSize: "14px", color: black, backgroundColor: "#ffffff" }}
      className="min-h-screen"
      data-testid="home-page"
    >
      <header className="border-b border-gray-200 sticky top-0 bg-white z-20">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-md flex items-center justify-center" style={{ backgroundColor: black }}>
              <Sparkles className="w-4 h-4 text-white" />
            </div>
            <span style={{ fontSize: "18px" }} className="font-bold tracking-wide">YVOLA</span>
          </div>
          <nav className="flex items-center gap-4">
            <Link to="/login" data-testid="home-login-link" className="hover:underline">Autentificare</Link>
            <Link
              to="/signup"
              data-testid="home-signup-top"
              className="px-3 py-1.5 rounded-md text-white hover:opacity-90 transition-opacity"
              style={{ backgroundColor: black }}
            >
              Inregistreaza firma
            </Link>
          </nav>
        </div>
      </header>

      {/* HERO */}
      <section className="max-w-6xl mx-auto px-6 pt-16 pb-14 grid gap-12 lg:grid-cols-2 items-center">
        <div>
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full border" style={{ borderColor: accent, color: accent, fontSize: "12px" }}>
            <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: accent }} /> Ecosistem de aplicatii pentru firme
          </span>
          <h1 style={{ fontSize: "40px", lineHeight: "1.1" }} className="font-bold mt-5">
            Yvola nu e o aplicatie, ci este un ecosistem care iti creste firma.
          </h1>
          <p style={{ fontSize: "16px", lineHeight: "1.6" }} className="mt-5 text-gray-700">
            De la 2-3 angajati la sute sau mii. De la cateva sute de mii cifra de afaceri la milioane sau zeci de
            milioane. Aplicatiile Yvola lucreaza impreuna, ca un organism, si iti dau predictibilitatea pe care o
            cauti intr-o piata neclara.
          </p>
          <p style={{ fontSize: "15px", lineHeight: "1.6" }} className="mt-4 font-semibold">
            Contactam noi pentru tine potentialii clienti din Uniunea Europeana pe multiple canale de comunicatie si
            iti aducem in CRM doar pe cei care isi arata interesul de a colabora cu firma ta.
          </p>
          <p style={{ fontSize: "15px", lineHeight: "1.6" }} className="mt-3 text-gray-700">
            Platesti raportat "la consum", adica in functie de numarul noilor parteneri pe care ti-i doresti (exemplu:
            platesti 10 si primesti 10 care doresc sa colaboreze cu tine), fara costuri ascunse.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/signup"
              data-testid="home-signup-hero"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-white hover:opacity-90 transition-opacity"
              style={{ backgroundColor: black, fontSize: "15px" }}
            >
              Creeaza cont firma <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/login"
              data-testid="home-login-hero"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-gray-300 hover:border-gray-900 transition-colors"
              style={{ fontSize: "15px" }}
            >
              Am deja cont
            </Link>
          </div>
        </div>
        <img
          src={IMG.hero}
          alt="Echipa care creste afacerea"
          data-testid="home-hero-image"
          className="w-full h-80 lg:h-[26rem] object-cover rounded-xl border border-gray-200"
        />
      </section>

      {/* ECOSISTEM - card strip */}
      <section className="border-t border-gray-200 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 py-16">
          <h2 style={{ fontSize: "24px" }} className="font-bold">Un ecosistem, nu piese razlete</h2>
          <p className="mt-2 text-gray-600" style={{ fontSize: "15px" }}>
            Cateva instrumente esentiale, adaptate afacerii tale, functionand ca un singur organism.
          </p>
          <div className="mt-10 grid gap-8 md:grid-cols-3">
            {ecosystem.map((f, i) => (
              <div key={i} data-testid={`home-eco-${i}`} className="bg-white rounded-xl border border-gray-200 overflow-hidden flex flex-col hover:shadow-lg transition-shadow">
                <img src={f.img} alt={f.t} className="w-full h-44 object-cover" data-testid={`home-eco-img-${i}`} />
                <div className="p-6 flex-1 flex flex-col">
                  <div className="w-9 h-9 rounded-md flex items-center justify-center mb-3" style={{ backgroundColor: black }}>
                    <f.icon className="w-4 h-4 text-white" />
                  </div>
                  <h3 style={{ fontSize: "17px" }} className="font-bold">{f.t}</h3>
                  <p className="mt-2 text-gray-700" style={{ fontSize: "14px", lineHeight: "1.6", whiteSpace: "pre-line" }}>{f.d}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Asistent AI callout */}
          <div className="mt-8 bg-white rounded-xl border border-gray-200 p-6 md:p-8 grid gap-6 md:grid-cols-2 items-center" data-testid="home-ai-block">
            <div>
              <div className="w-9 h-9 rounded-md flex items-center justify-center mb-3" style={{ backgroundColor: accent }}>
                <Bot className="w-4 h-4 text-white" />
              </div>
              <h3 style={{ fontSize: "19px" }} className="font-bold">Asistent AI, disponibil 24/7</h3>
              <p className="mt-2 text-gray-700" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                Cand complexitatea creste si nu mai ai timp sa asimilezi informatii, iti punem la dispozitie un
                asistent docil si inteligent care iti raspunde prompt la intrebari, oricand.
              </p>
              <p className="mt-3 font-semibold" style={{ fontSize: "14px" }}>
                Nu confunda cu ChatGPT sau alte servicii free ori platite: acelea nu au acces la firma ta pana la
                "ultima cifra".
              </p>
              <p className="mt-2 text-gray-700" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                Instrumentele soft puse de Yvola pentru tine iti dau claritate ca sa poti decide logic, pe baza
                cifrelor introduse.
              </p>
            </div>
            <img src={IMG.ai} alt="Asistent AI" className="w-full h-56 object-cover rounded-lg border border-gray-200" data-testid="home-ai-img" />
          </div>
        </div>
      </section>

      {/* POVESTE - predictibilitate prin volum */}
      <section className="border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6 py-16 grid gap-12 lg:grid-cols-2 items-start">
          <img
            src={IMG.story}
            alt="Productie de comenzi nestandard"
            data-testid="home-story-image"
            className="w-full h-full max-h-[30rem] object-cover rounded-xl border border-gray-200 order-last lg:order-first"
          />
          <div>
            <span className="inline-flex items-center gap-2" style={{ color: accent, fontSize: "13px" }}>
              <TrendingUp className="w-4 h-4" /> Predictibilitate prin volum
            </span>
            <h2 style={{ fontSize: "24px", lineHeight: "1.2" }} className="font-bold mt-3">
              Cand ai de unde alege, tu conduci afacerea, nu invers.
            </h2>
            <div className="mt-5 space-y-4 text-gray-700" style={{ fontSize: "15px", lineHeight: "1.65" }}>
              <p>
                Intr-o piata nesigura, predictibilitatea e cea mai importanta parte, iar pentru ea conteaza volumul
                comenzilor. Daca poti prelucra 10 comenzi intr-un interval, dar iti vin doar 5, vei accepta aproape
                orice numai sa ai continuitate.
              </p>
              <p>
                Dar daca poti prelucra aceleasi 10 comenzi, iar tie iti vin 20 de solicitari, alegi clientii cu care
                rezonezi si urci un pic pretul. Prinzi curaj sa angajezi si sa mai cumperi un utilaj sau alt activ.
              </p>
              <p>
                Apoi vrei sa vezi afacerea pe termen lung: iei un credit, accesezi fonduri sau aduci un finantator
                care ii da un boost. Sa stii ca iti intra lunar X colaboratori noi, care aduc Y comenzi, care
                genereaza o cifra de afaceri Z si un profit W estimabil, adica sa vezi mai departe de ziua de maine.
              </p>
              <p>
                Un asemenea ecosistem, functionand ca un organism, iti da o predictibilitate mult mai buna decat ceva
                facut la intamplare sau din auzite.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CUM AR FI SA... */}
      <section className="border-t border-gray-200 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 py-16">
          <h2 style={{ fontSize: "24px" }} className="font-bold">Cum ar fi sa...</h2>
          <div className="mt-8 grid gap-6 md:grid-cols-3">
            {[
              "...ai acces la tot si sa platesti strict ceea ce consumi?",
              "...vezi cum functioneaza firmele mari, ca sa te inspiri?",
              "...vezi afacerea pe termen lung, nu doar pana maine?",
            ].map((q, i) => (
              <div key={i} data-testid={`home-question-${i}`} className="bg-white rounded-xl border border-gray-200 p-6">
                <span className="font-bold" style={{ color: accent, fontSize: "22px" }}>{i + 1}</span>
                <p className="mt-2 font-semibold" style={{ fontSize: "16px", lineHeight: "1.5" }}>{q}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* INCEPUTUL E SIMPLU */}
      <section className="border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6 py-16">
          <h2 style={{ fontSize: "24px" }} className="font-bold">Inceputul este simplu</h2>
          <p className="mt-2 text-gray-600" style={{ fontSize: "15px" }}>
            Cateva minute la start, apoi ecosistemul lucreaza pentru tine.
          </p>
          <ol className="mt-8 grid gap-5 md:grid-cols-2">
            {[
              "Iti creezi user pe firma ta.",
              "Te contactam noi si ne povestesti in cateva minute afacerea ta.",
              "Punem AI-ul la treaba pe datele afacerii tale.",
              "Incep sa iti vina solicitari pe e-mail de la potentiali clienti.",
              "Le gestionezi in CRM prin notite, activitati si canale de contact.",
              "Pe masura ce prinzi curaj, folosesti tot mai intens ecosistemul, adaptat afacerii tale.",
            ].map((s, i) => (
              <li key={i} className="flex gap-3 items-start" data-testid={`home-step-${i}`}>
                <span
                  className="w-7 h-7 rounded-full text-white flex items-center justify-center flex-shrink-0 font-bold"
                  style={{ backgroundColor: black, fontSize: "13px" }}
                >
                  {i + 1}
                </span>
                <span style={{ fontSize: "15px", lineHeight: "1.55" }}>{s}</span>
              </li>
            ))}
          </ol>
          <Link
            to="/signup"
            data-testid="home-signup-bottom"
            className="mt-10 inline-flex items-center gap-2 px-6 py-3 rounded-md text-white hover:opacity-90 transition-opacity"
            style={{ backgroundColor: black, fontSize: "15px" }}
          >
            Incepe acum <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>

      {/* CONTACT */}
      <section className="border-t border-gray-200 bg-gray-50" data-testid="home-contact-section">
        <div className="max-w-6xl mx-auto px-6 py-16 grid gap-10 lg:grid-cols-2 items-start">
          <div>
            <h2 style={{ fontSize: "24px" }} className="font-bold">Contacteaza-ne</h2>
            <p className="mt-3 text-gray-700" style={{ fontSize: "15px", lineHeight: "1.6" }}>
              Ai intrebari despre Yvola sau vrei sa vezi cum ti se potriveste ecosistemul? Lasa-ne un mesaj si te
              contactam noi.
            </p>
          </div>
          <PlatformContactForm />
        </div>
      </section>

      <footer className="border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between text-gray-600">
          <span className="font-bold" style={{ color: black }}>YVOLA</span>
          <span>yvola.eu</span>
        </div>
      </footer>
      <WhatsAppSupport />
    </div>
  );
}
